import { useFlags } from 'launchdarkly-react-client-sdk';
import { useMemo } from 'react';
import { validateFeatureFlagName } from '../constants';
import { FlagState } from '../types/FlagState';
import { useFeatureFlagsReady } from './useFeatureFlagsReady';

export function useMultipleFeatureFlags(...featureFlags: string[]): FlagState[] {
  const ready = useFeatureFlagsReady();
  const flagState = useFlags();

  featureFlags.forEach(validateFeatureFlagName);

  return useMemo(
    () =>
      featureFlags.map((name) => ({
        enabled: !!flagState[name],
        value: flagState[name],
        ready,
      })),
    [flagState, ready, ...featureFlags],
  );
}
